import Head from "next/head";
import { make as TeamBuilderPage } from "../../src/team-planner-core/TeamPlannerPage.bs";
import { qsToTitle as qsToTitle10 } from "../../src/team-planner10/TbPage10.bs";
import { qsToTitle as qsToTitle13 } from "../../src/team-planner13/TbPage13.bs";
import { qsToTitle as qsToTitle14 } from "../../src/team-planner14/TbPage14.bs";

export default function TeamBuilder({ exalteds, board = "", locale }) {
  const content = `https://legendsapi.com/team-builder-preview/${
    locale == "en" ? "" : `${locale}/`
  }${board}`;

  let title = "";
  let set = "14";

  try {
    const title10 = qsToTitle10(board);
    const title13 = qsToTitle13(board);
    const title14 = qsToTitle14(board);

    let maxLen = Math.max(title10.length, title13.length, title14.length);
    if (title14.length === maxLen) {
      title = title14;
      set = "14";
    } else if (title13.length === maxLen) {
      title = title13;
      set = "13";
    } else if (title10.length === maxLen) {
      title = title10;
      set = "10";
    }
  } catch (_) {}

  return (
    <>
      <Head>
        <meta content={title} property="og:title" />
        <meta property="og:image" content={content} />
        <meta name="twitter:card" content="summary_large_image" />
        <title>{`${title} - TFT Team Builder Set ${set}`}</title>
      </Head>
      <TeamBuilderPage
        locale={locale}
        initialBoard={board}
        exalteds={exalteds}
      />
    </>
  );
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}

export async function getStaticProps({ locale, params }) {
  const exaltedsResp = await fetch(
    `https://ap.tft.tools/static/s11/exalteds.json`,
  );
  const exalteds = await exaltedsResp.json();

  return {
    props: {
      exalteds,
      board: params.board,
      locale,
    },
  };
}
